import { AnySourceStream, Stream } from '../stream'
import { deepClone } from '@hypatia/utils/object/deep-clone'
import { Pass } from './pass'

export class DeepClone<V = any, E = any, C = any> extends Pass<V, E, C> {
    value(value: V) {
        this._value(deepClone(value))
    }
}

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        deepClone<T>(): MirrorStream<DV, DE, DC>
    }
}

Stream.prototype.deepClone = function <SV, SE, SC>(this: AnySourceStream<SV, SE, SC>) {
    return new DeepClone(this) // tslint:disable-line:no-invalid-this
}
